// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__Nb7Rg","inputWrap":"CustomTip_inputWrap__pjqD6"};